// frontend/src/main/FormFields/Motori.js

import React, { useContext } from 'react'
import { FormGroup, Input, FormText, Row, Col } from 'reactstrap'

export default function Motori({ context }) {
  const {
    engine,
    setEngine,
    engines,
    locale,
    setLocale,
    locales,
  } = useContext(context)

  return (
    <Row>
      <Col xs={12} md={6}>
        <FormGroup>
          <label htmlFor="engine" className="form-control-label">
            Motore
          </label>
          <Input
            className="form-control-alternative"
            type="select"
            id="engine"
            required={true}
            value={engine}
            onChange={e => setEngine(e.target.value)}
          >
            <option value="" disabled>Seleziona un motore</option>
            {engines.map(m => (
              <option value={m} key={m}>
                {m}
              </option>
            ))}
          </Input>
          <FormText color="muted" align={'left'}>
            Seleziona un motore di ricerca
          </FormText>
        </FormGroup>
      </Col>
      <Col xs={12} md={6}>
        <FormGroup>
          <label htmlFor="locale" className="form-control-label">
            Locale
          </label>
          <Input
            className="form-control-alternative"
            type="select"
            id="locale"
            required={true}
            value={locale}
            onChange={e => setLocale(e.target.value)}
            disabled={!engine || locales.length === 0}
          >
            <option value="" disabled>Seleziona un locale</option>
            {locales.map(l => (
              <option value={l} key={l}>
                {l}
              </option>
            ))}
          </Input>
          <FormText color="muted" align={'left'}>
            Seleziona un locale
          </FormText>
        </FormGroup>
      </Col>
    </Row>
  )
}